angular.module("app").directive("cityTopFourColorAcrossSeasons", () => {
  let link = (scope) => {
    scope.$watch('data', (data) => {
      if (data) {
        scope.data.map(obj => {
          if(obj.name === 'pre_fall'){
            obj.name = 'pre fall'
          }
        });
      }
    });
  };

  return {
    restrict: "E",
    templateUrl: "app/directives/dbCityTopFourColorAcrossSeasons/dbCityTopFourColorAcrossSeasonsView.html",
    link: link,
    scope: {
      data: "=",
      type: "="
    }
  };
});
